module.exports = __webpack_public_path__ + "img/graph_compar.ace65ef7.jpg";